<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/currencyconfig" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("system.label.Create") }} {{ currency.type }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <vx-card>
        <!-- <div class="vx-row">
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/6 xl:w-1/6">
          <input
            id="Currency"
            type="radio"
            value="Currency"
            v-model="currency.type"
            checked
          />
          <label for="Currency"> {{ $t("system.label.currency") }} </label>
        </div>
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/6 xl:w-1/6">
          <input
            id="Non-Currency"
            type="radio"
            value="Non-Currency"
            v-model="currency.type"
          />
          <label for="Non-Currency">
            {{ $t("system.label.nonCurrency") }}
          </label>
        </div>
      </div> -->
        <div class="vx-row mt-3">
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required|max:3"
              v-slot="{ errors }"
              :name="$t('system.label.code')"
            >
              <vs-input
                :label="$t('system.label.code')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="currency.code"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>

          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('system.label.decimalPlaces')"
            >
              <vs-input
                :label="$t('system.label.decimalPlaces')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="currency.decimalPlaces"
                type="number"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('system.label.name')"
            >
              <vs-input
                :label="$t('system.label.name')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="currency.name"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("customers.label.status")
                }}<span class="required">*</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('customers.label.status')"
              >
                <v-select
                  v-model="currency.status"
                  :options="statusOptions"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              v-if="currency.type == 'Currency'"
              :name="$t('system.label.displaySymbol')"
            >
              <vs-input
                :label="$t('system.label.displaySymbol')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="currency.displaySymbol"
                v-if="currency.type == 'Currency'"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              v-if="currency.type == 'Currency'"
              :name="$t('system.label.internationalNameCode')"
            >
              <vs-input
                :label="$t('system.label.internationalNameCode')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="currency.nameCode"
                v-if="currency.type == 'Currency'"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <vs-input
              :label="$t('system.label.countryCode')"
              class="w-full mb-2 font-semibold"
              v-model="currency.countryCode"
              v-if="currency.type == 'Currency'"
            />
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <vs-input
              :label="$t('system.label.countryName')"
              class="w-full mb-2 font-semibold"
              v-model="currency.countryName"
              v-if="currency.type == 'Currency'"
            />
          </div>
        </div>
      </vx-card>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("system.label.reset") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="validateForm"
            >{{ $t("system.label.submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <div class="centerx">
      <vs-popup
        class="warning-msg popup-close"
        classContent="popup-example"
        :title="null"
        :active.sync="warningPopup"
      >
        <div
          style="font-size: 20px; color: rgb(255, 204, 0); margin-left: 10px"
          v-if="warningText"
        >
          ⚠ Warning!!
        </div>
        <div
          style="font-size: 20px; color: orangered; margin-left: 10px"
          v-if="errorMessage"
        >
          ⛔ Error!!
        </div>

        <div class="font-semibold p-3">
          {{ warningText }}
          {{ errorMessage }}
        </div>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const currencyEmptyObj = {
  type: "Currency",
  code: "",
  nameCode: "",
  decimalPlaces: "",
  countryCode: "",
  countryName: "",
  name: "",
  displaySymbol: "",
  locale: "en",
  status: "",
};

export default {
  data() {
    return {
      breadcrumbs: [
        {
          name: this.$t("reports.label.currencyMaster"),
          to: "/currencyconfig",
        },
        { name: this.$t("Create ") + this.$route.query.type, to: "/" },
      ],
      currency: currencyEmptyObj,
      warningPopup: false,
      warningText: "",
      errors: [],
      statusOptions: ["ACTIVE", "INACTIVE"],
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      postResponse: (state) => state.currencyMaster.createCurrency,
      errorMessage: (state) => state.currencyMaster.formError,
    }),
  },
  methods: {
    async validateForm() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      this.createCurrency();
    },
    async createCurrency() {
      this.noncurrency = {
        type: this.currency.type,
        code: this.currency.code,
        decimalPlaces: this.currency.decimalPlaces,
        status: this.currency.status,
        name: this.currency.name,
        locale: "en",
      };
      await this.$store.dispatch(
        "currencyMaster/setPostCurrency",
        this.currency || this.noncurrency
      );

      if (this.postResponse) {
        this.resetForm();
        this.$router.push(`/currencyconfig`);
        this.$swal({
          title: "Success",
          icon: "success",
          text:
            this.currency.type == "Currency"
              ? "Currency Created Successfully!"
              : "Non-Currency Created Successfully!",
          type: "success",
        });
      }
      if (this.errorMessage) {
        this.warningPopup = true;
      }
    },
    resetForm() {
      this.currency = currencyEmptyObj;
      this.currency.code = "";
      this.currency.decimalPlaces = "";
      this.currency.name = "";
      this.currency.displaySymbol = "";
      this.currency.nameCode = "";
      this.currency.countryName = "";
      this.currency.countryCode = "";
      this.currency.status = "";
    },
  },
  watch: {},
  mounted() {
    this.resetForm();

    this.currency.type = this.$route.query.type;
    // Select the breadcrumb element
    const breadcrumb = document.querySelector(".breadcrumb");

    if (breadcrumb) {
      const lastChild = breadcrumb.lastElementChild;

      if (lastChild) {
        lastChild.textContent = `Create ${this.currency.type}`;
      }
    }
  },
};
</script>
<style></style>
